import {Mount} from "@shared/enums";
import {CompatibilityLevel} from "@/scripts/components/ab-lens-compatibility/abLensCompatibility.enums";
import {ProductResponseDTO} from "@shared/DTO";
import {
  getLensMountAffiliates,
  LensMountAffiliate,
} from "@/scripts/utils/lens-mount-affiliates.utils";

export interface LensCompatibilityRule extends LensMountAffiliate {}

export const getLensCompatibilityRules = (
  lens: ProductResponseDTO
): LensCompatibilityRule[] => {
  return getLensMountAffiliates(lens);
}

export const getBestCompatibility = (
  lensMounts: Mount[],
  cameraMount: Mount
): { mount: Mount, compatibilityLevel: CompatibilityLevel } => {

  const fullyCompatibleMount = lensMounts?.find((mount) => {
    if (mount === cameraMount) {
      return true;
    }
    if (!mount.endsWith('0')) {
      return false;
    }
    // subMountId è il 'sotto-mount' (es. EF-S) corrispondente al mount (es. EF) da considerarsi del tutto compatibile
    const subMountId = `${mount.slice(0, -1)}1` as Mount;
    if (!mountExists(subMountId)) {
      return false;
    }
    if (subMountId === cameraMount) {
      return true;
    }
  });

  if (fullyCompatibleMount) {
    return {
      mount: fullyCompatibleMount,
      compatibilityLevel: CompatibilityLevel.FULL
    }
  }

  const partiallyCompatibleMount = lensMounts
    ?.find((mount) => {
      if (!mount.endsWith('1')) {
        return false;
      }
      const parentMountId = `${mount.slice(0, -1)}0` as Mount;
      if (!mountExists(parentMountId)) {
        return false;
      }
      if (cameraMount !== parentMountId) {
        return false;
      }
      // Mounts per i quali vale la regola che obiettivo in formato APS-C può essere utilizzato su full-frame sia pure con limitazioni
      const apsCompatibleWithFullFrame = [
        Mount.CANON_RF,
        Mount.NIKON_F,
        Mount.NIKON_Z,
        Mount.SONY_E,
        Mount.PENTAX_K,
        Mount.L_MOUNT];
      return apsCompatibleWithFullFrame.includes(parentMountId);
    });

  if (partiallyCompatibleMount) {
    return {
      mount: partiallyCompatibleMount,
      compatibilityLevel: CompatibilityLevel.PARTIAL
    }
  }
  return {
    mount: null,
    compatibilityLevel: CompatibilityLevel.NOT_COMPATIBLE
  };
}

const mountExists = (mountId: string | number) => {
  return Object.entries(Mount)
    ?.some(([_, mount]) => mount === mountId?.toString());
}
